import { CONTACT_POINT_SYSTEM } from "utils/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";
import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";

const AdherentBirthDate = ({
  project,
  onNext,
  onBack,
  currentStatus,
  tracer,
}) => {

  const onSubmit = ({ birthDate, telecoms }) => {
    const updatedTelecoms = map(telecoms, (item, key) =>
      defaults(
        { ...item, value: item?.value != null ? String(item.value) : null },
        { id: cuid(), system: key }
      )
    );
    
    onNext({
      payload: {
        contact: {
          ...get(project, "contact", {}),
          user: {
            id: get(project, "contact.user.id") || cuid(),  
            ...get(project, "contact.user", {}),
            birthDate,
          },
          telecoms: updatedTelecoms,
        },
      },
    });
  };

  const telecomsObject = defaults(
    keyBy(get(project, "contact.telecoms", []), "system"),
    {
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null }, 
    }
  );

  return (
    <>
      <Navbar project={project} progress={currentStatus?.progress} />
      <View
        contact={get(project, "contact", {})}
        telecoms={telecomsObject}
        onNext={onSubmit}
        onBack={onBack}
        tracer={tracer}
      />
    </>
  );
};

export default AdherentBirthDate;
